// Merkan · Wörterbuch Englisch: Service Hub (src/seiten/hub)
export default {
  // Seite, Ansicht
  'Service Hub': 'Service Hub',
  'Ansicht': 'View',
  'Board': 'Board',
  'Liste': 'List',
  'Unterhaltung': 'Conversation',
  'Schließen': 'Close',
  'Eingang': 'Inbox',
  'Keine Nachricht gewählt': 'No message selected',
  'Wähle links eine Nachricht, um die Unterhaltung zu sehen.': 'Select a message on the left to view the conversation.',
  'Telefonnotiz': 'Phone note',

  // Eingang und Board
  'Neu': 'New',
  'In Bearbeitung': 'In progress',
  'Wartet auf Kunde': 'Awaiting customer',
  'Wartet auf Lieferant': 'Awaiting supplier',
  'Erledigt': 'Done',
  'Status konnte nicht geändert werden.': 'The status could not be changed.',
  'Verschoben nach „{status}“.': 'Moved to "{status}".',
  'Betreff oder Absender suchen': 'Search subject or sender',
  'Postfach': 'Mailbox',
  'Alle Postfächer': 'All mailboxes',
  'Alle': 'All',
  'Meine': 'Mine',
  'Ohne Vorgang': 'Unassigned',
  'Auch zugeordnete': 'Incl. assigned',
  'Kategorien': 'Categories',
  'Ohne Kategorie': 'No category',
  'In den letzten 14 Tagen nichts erledigt': 'Nothing completed in the last 14 days',
  'Keine Nachrichten': 'No messages',
  'Unbekannt': 'Unknown',
  '(ohne Betreff)': '(no subject)',
  'Zuständig: {name}': 'Assignee: {name}',
  'Status': 'Status',
  'Alle offenen': 'All open',
  'Alle Status': 'All statuses',
  'Kategorie': 'Category',
  'Alle Kategorien': 'All categories',
  'Kein Eintrag passt zu den Filtern.': 'No entry matches the filters.',
  'Der Eingang ist leer.': 'The inbox is empty.',
  'Ungelesen': 'Unread',
  '{seit} unbeantwortet': 'Unanswered for {seit}',
  'Gelesen von {name}': 'Read by {name}',
  '{n} Kundenmail länger als {h} Stunden unbeantwortet': '{n} customer email unanswered for more than {h} hours',
  '{n} Kundenmails länger als {h} Stunden unbeantwortet': '{n} customer emails unanswered for more than {h} hours',
  '{n} Anhang': '{n} attachment',
  '{n} Anhänge': '{n} attachments',
  'seit {n} Stunde': '{n} hour',
  'seit {n} Stunden': '{n} hours',
  'seit {n} Tagen': '{n} days',

  // Absenderarten
  'Kunde': 'Customer',
  'Lieferant': 'Supplier',
  'Interessent': 'Prospect',
  'Intern': 'Internal',

  // Unterhaltung
  '{n} Nachricht': '{n} message',
  '{n} Nachrichten': '{n} messages',
  'Gelesen von': 'Read by',
  'Antworten': 'Reply',
  'Weiterleiten': 'Forward',
  'Notiz': 'Note',
  'Nachricht nicht gefunden': 'Message not found',
  'Sie wurde gelöscht oder du hast keinen Zugriff auf das Postfach.': 'It has been deleted or you do not have access to the mailbox.',
  'Der Anhang ist nicht verfügbar.': 'The attachment is not available.',
  'Gesendet': 'Sent',
  'aus {adresse}': 'from {adresse}',
  'Interne Notiz': 'Internal note',
  'erfasst von {name}': 'recorded by {name}',
  'An {liste}': 'To {liste}',
  'Cc {liste}': 'Cc {liste}',
  'Nicht gesendet': 'Not sent',
  'Wird gesendet': 'Sending',
  'Kein Text': 'No text',
  'Übersetzung ins Englische': 'Translation into English',
  'Übersetzung ins Deutsche': 'Translation into German',

  // Antworten
  'Die Übersetzung ist gerade nicht möglich.': 'Translation is not available at the moment.',
  'Es ist kein Postfach gewählt, aus dem du senden darfst.': 'No mailbox you are allowed to send from is selected.',
  'Bitte mindestens eine gültige Empfängeradresse angeben.': 'Please enter at least one valid recipient address.',
  'Der Text ist leer.': 'The text is empty.',
  'Nachricht weitergeleitet.': 'Message forwarded.',
  'Antwort gesendet.': 'Reply sent.',
  'Die Notiz ist leer.': 'The note is empty.',
  'Notiz gespeichert.': 'Note saved.',
  'Ins Englische übersetzen': 'Translate into English',
  'Ins Deutsche übersetzen': 'Translate into German',
  'Abbrechen': 'Cancel',
  'Notiz speichern': 'Save note',
  'Erscheint in der Unterhaltung und in der Akte {nummer}.': 'Appears in the conversation and in the file of {nummer}.',
  'Erscheint nur intern in der Unterhaltung.': 'Appears internally in the conversation only.',
  'Wird gesendet …': 'Sending …',
  'Senden': 'Send',
  'Du darfst aus keinem Postfach senden. Die Freigabe erteilt die Verwaltung unter Einstellungen, Postfächer.': 'You are not allowed to send from any mailbox. An administrator can grant approval under Settings, Mailboxes.',
  'Von': 'From',
  'Sammelpostfach': 'Shared mailbox',
  'Sprache': 'Language',
  'Deutsch': 'German',
  'Englisch': 'English',
  'An': 'To',
  'name@firma.example': 'name@company.example',
  'Cc': 'Cc',
  'Betreff': 'Subject',
  'Textbaustein einfügen': 'Insert text template',
  'Keine Textbausteine in dieser Sprache': 'No text templates in this language',
  'Nur auf Deutsch, wird übersetzt': 'Only in German, will be translated',
  'Nur auf Englisch, wird übersetzt': 'Only in English, will be translated',
  'Textbaustein wird übersetzt …': 'Translating text template …',
  'Wird übersetzt …': 'Translating …',
  'Text': 'Text',
  'Der Text scheint Deutsch zu sein, der Empfänger schreibt Englisch.': 'The text appears to be in German, the recipient writes in English.',
  'Der Text scheint Englisch zu sein, der Empfänger schreibt Deutsch.': 'The text appears to be in English, the recipient writes in German.',
  'Hinweis schließen': 'Dismiss notice',
  'Übersetzung': 'Translation',
  'Übersetzung verwenden': 'Use translation',
  'Verwerfen': 'Discard',
  'Original': 'Original',
  'Signatur': 'Signature',
  'Firmensignatur des Sammelpostfachs': 'Company signature of the shared mailbox',
  'Deine persönliche Signatur': 'Your personal signature',
  'Originalnachricht anhängen': 'Attach original message',
  'Originaltext zitieren': 'Quote original text',
  'Anhänge der Originalnachricht werden nicht mitgesendet.': 'Attachments of the original message are not included.',

  // Interessent anlegen
  'Bitte die Firma angeben.': 'Please enter the company.',
  'Bitte den Nachnamen des Ansprechpartners angeben.': 'Please enter the contact person\'s surname.',
  'Die Interessentennummer konnte nicht vergeben werden. Bitte erneut versuchen.': 'The prospect number could not be assigned. Please try again.',
  'Interessent {nummer} angelegt.': 'Prospect {nummer} created.',
  'Interessent anlegen': 'Create prospect',
  "Vorbefüllt aus der Auswertung der Signatur durch {ki}. Bitte prüfen.": "Prefilled from {ki}'s analysis of the signature. Please check.",
  "Vorbefüllt aus dem Absender. Mit der Auswertung von {ki} werden mehr Felder erkannt.": "Prefilled from the sender. Analysis by {ki} recognises more fields.",
  'Wird angelegt …': 'Creating …',
  'Firma': 'Company',
  'Domain': 'Domain',
  'Künftige Mails dieser Domain werden zugeordnet': 'Future emails from this domain will be assigned',
  'reederei.example': 'shipowner.example',
  'Straße': 'Street',
  'PLZ': 'Postcode',
  'Ort': 'City',
  'Land': 'Country',
  'Telefon': 'Phone',
  'E-Mail': 'Email',
  'USt-IdNr.': 'VAT ID',
  'Ansprechpartner': 'Contact person',
  'Vorname': 'First name',
  'Nachname': 'Surname',
  'Funktion': 'Position',
  'z. B. Technischer Inspektor': 'e.g. Technical Superintendent',
  'Erkanntes Schiff: {schiff}. Das Schiff wird im Stamm unter Schiffe angelegt.': 'Recognised vessel: {schiff}. The vessel will be created in Master Data under Vessels.',
  'Die Kundennummer wird automatisch als I-Nummer vergeben.': 'The customer number is assigned automatically as an I number.',

  // Seitenleiste
  'niedrig': 'low',
  'normal': 'normal',
  'hoch': 'high',
  'Absender': 'Sender',
  'Name': 'Name',
  'Kontakt': 'Contact',
  'Weder Kontakt noch Domain': 'Neither the contact nor the domain',
  'sind im Stamm bekannt.': 'is known in Master Data.',
  'Der Absender ist im Stamm nicht bekannt.': 'The sender is not known in Master Data.',
  'Unterhaltung dem Vorgang zugeordnet. Sie liegt jetzt im Vorgang und verschwindet aus dem Eingang.': 'Conversation assigned to the case. It now sits in the case and disappears from the inbox.',
  'Vorgang {nummer} angelegt.': 'Case {nummer} created.',
  'Vorgang angelegt.': 'Case created.',
  'Vorgang': 'Case',
  'Noch keinem Vorgang zugeordnet.': 'Not yet assigned to a case.',
  'Vorgang anlegen': 'Create case',
  'Für einen neuen Vorgang zuerst den Absender als Interessent anlegen.': 'To open a new case, first create the sender as a prospect.',
  'Anlegen': 'Create',
  'Die ganze Unterhaltung wird dem neuen Vorgang zugeordnet. Die Nummer vergibt Merkan automatisch.': 'The whole conversation will be assigned to the new case. Merkan assigns the number automatically.',
  'Andere Auswahl': 'Change selection',
  'Vorgang suchen (Kunde zuerst)': 'Search case (customer first)',
  'Vorgang suchen: Nummer, Betreff, Kunde': 'Search case: number, subject, customer',
  'Vorgang suchen': 'Search case',
  'Kein offener Vorgang gefunden': 'No open case found',
  'dieser Kunde': 'this customer',
  'Zuordnen': 'Assign',
  'Zuständigkeit entfernt.': 'Assignee removed.',
  'Kategorie: {kategorie}': 'Category: {kategorie}',
  'Kategorie entfernt.': 'Category removed.',
  'Bearbeitung': 'Handling',
  'Status: {status}': 'Status: {status}',
  'Zuständig': 'Assignee',
  'Vorschlag:': 'Suggestion:',
  'Niemand': 'Nobody',
  "Von {ki} vorgeschlagen (KI), Sicherheit {wert} %": "Suggested by {ki} (AI), confidence {wert} %",
  'Keine': 'None',
  'Die Auswertung ist gerade nicht möglich.': 'The analysis is not available at the moment.',
  'Kategorie übernommen: {kategorie}': 'Category applied: {kategorie}',
  "Auswertung von {ki}": "Analysis by {ki}",
  'Wertet aus …': 'Analysing …',
  'Neu auswerten': 'Analyse again',
  "Mit {ki} auswerten": "Analyse with {ki}",
  'Kategorie, Absender und Schiff aus der Mail erkennen lassen.': 'Have category, sender and vessel recognised from the email.',
  'übernommen': 'applied',
  'Übernehmen': 'Apply',
  'Nächster Schritt': 'Next step',
  'Dringlichkeit': 'Urgency',
  'Referenz': 'Reference',
  'Schiff': 'Vessel',
  'In der Schiffssuche öffnen': 'Open in vessel search',
  'Schiff suchen': 'Search vessel',
  'nicht im Stamm': 'not in Master Data',
  'Ausgewertet {zeit}': 'Analysed {zeit}',

  // Telefonnotiz
  'Bitte einen Betreff angeben.': 'Please enter a subject.',
  'Bitte einen Kunden wählen oder den Anrufer eintragen.': 'Please select a customer or enter the caller.',
  'Telefonnotiz erfasst.': 'Phone note recorded.',
  'Erscheint im Eingang und, wenn zugeordnet, in der Akte des Vorgangs.': 'Appears in the inbox and, if assigned, in the case file.',
  'Wird gespeichert …': 'Saving …',
  'Erfassen': 'Record',
  'Kunde entfernen': 'Remove customer',
  'Firma oder Kundennummer': 'Company or customer number',
  'Kein bestimmter Kontakt': 'No specific contact',
  'Anrufer': 'Caller',
  'Für diesen Kunden ist kein Kontakt hinterlegt.': 'No contact is stored for this customer.',
  'Name und Firma, falls der Kunde nicht im Stamm ist.': 'Name and company, if the customer is not in Master Data.',
  'z. B. Rückfrage Liefertermin': 'e.g. query on delivery date',
  'Gesprächsnotiz': 'Call notes',
  'Keinem Vorgang zuordnen': 'Do not assign to a case',
  'Bereits erledigt, keine weitere Aktion nötig': 'Already dealt with, no further action required',

  // Hilfen
  'Der Vorgang wurde nicht ausgeführt.': 'The action was not carried out.',
  'Der Server ist gerade nicht erreichbar. Bitte später erneut versuchen.': 'The server cannot be reached at the moment. Please try again later.',

  // Antwortfenster: Absender, Variablen, Logo
  'persönlich': 'personal',
  'Antwort aus {adresse} (Sammelpostfach), damit das Team den Verlauf sieht.': 'Reply from {adresse} (shared mailbox) so the team can follow the conversation.',
  'Aus eigenem Postfach senden': 'Send from my own mailbox',
  'Antwort aus deinem persönlichen Postfach. Das Team sieht sie nicht.': 'Reply from your personal mailbox. The team will not see it.',
  'Aus {adresse} senden': 'Send from {adresse}',
  'Zuletzt für diesen Kunden verwendet': 'Last used for this customer',
  'Folgende Variablen haben keinen Wert: {liste}': 'The following variables have no value: {liste}',
  'Text bearbeiten': 'Edit text',
  'Trotzdem senden': 'Send anyway',
  'Variablen im Text': 'Variables in the text',
  'Wird beim Senden eingesetzt:': 'Filled in when sending:',
  'Kein Wert': 'No value',
  'kein Wert': 'no value',
  'Firmenlogo unter der Signatur': 'Company logo below the signature',

  // Formulierung verbessern (KI-Aktion formulieren)
  'Formulierung verbessern': 'Improve wording',
  'Wird überarbeitet …': 'Revising …',
  'Überarbeitet den Text nach dem Schreibstil, Fakten und Variablen bleiben unverändert': 'Revises the text in line with the house style; facts and variables remain unchanged',
  'Die Formulierung kann gerade nicht verbessert werden.': 'The wording cannot be improved at the moment.',
  'Die Formulierung entspricht bereits dem Schreibstil.': 'The wording already meets the house style.',
  'Vorschlag': 'Suggestion',
  'Vorschlag übernehmen': 'Apply suggestion',
  '„{gruss}“ am Ende des Textes entfällt beim Senden, weil die Signatur bereits mit einer Grußformel beginnt.': '“{gruss}” at the end of the text will be removed when sending, as the signature already begins with a closing.',
  "Erkannte Artikel": "Recognised items",
  "Nicht im Artikelstamm, wird als neue Position erfasst": "Not in item master, will be added as a new line item",
  "Als Positionen in den Vorgang übernehmen": "Add as line items to the case",
  "Beim Anlegen des Vorgangs werden diese Artikel automatisch als Positionen übernommen.": "These items are added as line items automatically when the case is created.",
  "{n} Positionen in den Vorgang übernommen.": "{n} line items added to the case.",
  "Alle erkannten Artikel stehen bereits im Vorgang.": "All recognised items are already in the case.",
  "Alle erkannten Artikel stehen im Vorgang.": "All recognised items are in the case.",
  "{n} fehlende Artikel in den Vorgang übernehmen": "Add {n} missing items to the case",
  "Vorgang {nummer} mit {n} erkannten Positionen angelegt.": "Case {nummer} created with {n} recognised line items.",
  "Der Text scheint bereits in dieser Sprache zu sein": "The text already appears to be in this language",
  "Anhang der Originalnachricht mitsenden": "Include the attachment of the original message",
  "{n} Anhänge der Originalnachricht mitsenden": "Include {n} attachments of the original message",
  "Preis in {w}": "Price in {w}",
  "Keine erkannte Position passt zu den Positionen des Vorgangs.": "No recognised item matches the items of the case.",
  "{n} Angebote übernommen, ohne passende Position: {liste}": "{n} offers added, without matching item: {liste}",
  "{n} Angebote von {lieferant} in die Kalkulation übernommen.": "{n} offers from {lieferant} added to the costing.",
  "ab Lager": "ex stock",
  "Als Lieferantenangebot in die Kalkulation übernehmen": "Add to costing as supplier offer",
  "Zum Übernehmen der Preise den Absender einem Lieferanten zuordnen.": "To add the prices, assign the sender to a supplier.",
  // Branchenneutrale Fassungen (Mandanten ohne Schiffsakte)
  "Kategorie, Absender und Positionen aus der Mail erkennen lassen.": "Let the mail be analysed for category, sender and line items.",
  "firma.example": "company.example",
  'In Arbeit': 'In progress',
  'Wartet auf Antwort': 'Awaiting reply',
  'Wartet auf Dritte': 'Awaiting third party',
  'Gelöst': 'Solved',
  'Ticket': 'Ticket',
  'In Vorgang überführen': 'Convert to case',
  'In Vorgang überführt': 'Converted to case',
  'Weiter im Vorgang': 'Continued in the case',
  'Eingegangen, noch nicht angefasst': 'Received, not yet touched',
  'Jemand kümmert sich': 'Someone is on it',
  'Rückfrage beim Absender offen': 'Question to the sender is open',
  'Lieferant, Hersteller oder Partner': 'Supplier, manufacturer or partner',
  'Letzte 14 Tage': 'Last 14 days',
  'Keine neuen Tickets': 'No new tickets',
  'Gerade nichts in Arbeit': 'Nothing in progress',
  'Keine offenen Rückfragen': 'No open questions',
  'Niemand extern angefragt': 'No one asked externally',
  'In den letzten 14 Tagen nichts gelöst': 'Nothing solved in the last 14 days',
  'Ticket hierher ziehen, um es in einen Vorgang zu überführen': 'Drag a ticket here to convert it into a case',
  'Hier ablegen, um einen Vorgang anzulegen oder zuzuordnen': 'Drop here to create or link a case',
  'Wird aus dem Ticket eine Anfrage, ein Auftrag oder ein Projekt, überführe es in einen Vorgang. Die ganze Unterhaltung zieht mit, das Ticket verlässt das Board.': 'If the ticket becomes an enquiry, an order or a project, convert it into a case. The whole conversation moves along and the ticket leaves the board.',
  'Neuen Vorgang anlegen': 'Create new case',
  'Absender anlegen und Vorgang starten': 'Add sender and start case',
  'Der Absender ist noch nicht im Stamm. Merkan legt ihn zuerst als Interessent an, danach den Vorgang.': 'The sender is not in master data yet. Merkan first adds them as a prospect, then the case.',
  'oder einem offenen Vorgang zuordnen': 'or link to an open case',
  'Ticket gelöst. Die Mail wird im Postfach nach „In Merkan verarbeitet“ verschoben.': 'Ticket solved. The email is moved to “Processed in Merkan” in the mailbox.',
  'Externe Bilder sind blockiert, damit der Absender nicht sieht, dass die Mail geöffnet wurde.': 'External images are blocked so the sender cannot see that the email was opened.',
  'Bilder anzeigen': 'Show images',
  'Immer für {domain}': 'Always for {domain}',
  'Original anzeigen': 'Show original',
  'Nur Text anzeigen': 'Show text only',
  'Mail': 'Email',
  'Ticket in Vorgang {nummer} überführt.': 'Ticket converted into case {nummer}.',
  'Ticket in den Vorgang überführt.': 'Ticket converted into the case.',
  'Für {firma}. Die ganze Unterhaltung zieht in den Vorgang.': 'For {firma}. The whole conversation moves into the case.',
  'Der Absender ist noch nicht im Stamm und wird mit dem Vorgang als Interessent angelegt.': 'The sender is not in master data yet and will be added as a prospect together with the case.',
  'Gespeichert wird erst mit „In Vorgang überführen“. Abbrechen verwirft alle Eingaben.': 'Nothing is saved until you click “Convert to case”. Cancel discards all entries.',
  '{n} erkannte Position übernommen.': '{n} detected item added.',
  '{n} erkannte Positionen übernommen.': '{n} detected items added.',
} satisfies Record<string, string>;
